/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type GetOrdersSortBy = typeof GetOrdersSortBy[keyof typeof GetOrdersSortBy];


export const GetOrdersSortBy = {
  id: 'id',
  orderNumber: 'orderNumber',
  finalPayableAmount: 'finalPayableAmount',
  createdAt: 'createdAt',
} as const;
